import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import { cidsActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../utils/permissions'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  handleSave = cid => {
    const { onClose, addCid, editCid, changeMessage } = this.props
    if (cid._id) {
      editCid(cid).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addCid(cid).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, cid) => {
    e.preventDefault()
    const { setCidFormTouched } = this.props

    if (this.props.cidFormErrors.valid) {
      this.handleSave(cid)
    } else {
      setCidFormTouched()
    }
    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      cid,
      handleChangeCid,
      loadingCid,
      cidFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('cids', token)

    const cidTypes = [
      {
        value: "cid10",
        name: "cid10"
      },
      {
        value: "cid11",
        name: "cid11"
      }
    ]

    return (
      <div>
        <Dialog
          modalId={cid._id ? 'cids-editar' : 'cids-novo'}
          modalParams={{ registro: cid._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingCid ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(cid._id ? 'cids-editar' : 'cids-novo') + '-title'}>
                {isReadOnly ? (
                  'CID'
                ) : (
                  <Fragment>
                    {cid._id ? 'Editar CID' : 'Cadastrar CID'}
                  </Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'cid-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, cid)
                  }}
                >
                  <FormControl
                    error={
                      !((cidFormErrors.fields || {})['codigo'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-codigo">Código</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeCid({ ...cid, codigo: e.target.value })
                      }}
                      value={cid.codigo}
                      autoFocus
                      id="field-codigo"
                    />
                    {!((cidFormErrors.fields || {})['codigo'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((cidFormErrors.fields || {})['codigo'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((cidFormErrors.fields || {})['nome'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Nome</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeCid({ ...cid, nome: e.target.value })
                      }}
                      value={cid.nome}
                      id="field-nome"
                    />
                    {!((cidFormErrors.fields || {})['nome'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((cidFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((cidFormErrors.fields || {})['tipo'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-tipo">Tipo</InputLabel>

                    <Select
                      id="field-tipo"
                      value={cid.tipo}
                      disabled={isReadOnly}
                      onChange={e => {
                        clearErrors()
                        handleChangeCid({ ...cid, tipo: e.target.value })
                      }}
                      fullWidth
                      required={'required'}
                    >
                      {cidTypes.map(item => {
                        return (
                          <MenuItem key={(item || {}).value} value={(item || {}).value}>
                            {(item || {}).name}
                          </MenuItem>
                        )
                      })}
                    </Select>
                    {!((cidFormErrors.fields || {})['tipo'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((cidFormErrors.fields || {})['tipo'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button type={'submit'} form={'cid-form'} color="primary" variant="raised">
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    cid: state.cids.cid,
    loadingCid: state.cids.loadingCid,
    cidFormErrors: state.cids.cidFormErrors,
    formTouched: state.cids.cidFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    handleChangeCid: cid => {
      dispatch(cidsActions.handleChangeCid(cid))
    },
    addCid: cid => {
      return dispatch(cidsActions.addCid(cid))
    },
    editCid: cid => {
      return dispatch(cidsActions.editCid(cid))
    },
    setCidFormTouched: () => {
      dispatch(cidsActions.setCidFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/Cids/EditModal.js